
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial/[slug]",
      function () {
        return require("private-next-pages/editorial/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial/[slug]"])
      });
    }
  